import sendWebVitalsResultsToAnalytics from './sendWebVitalsResultsToAnalytics'
import useReportWebVitals from './useReportWebVitals'

export default function WebVitals() {
  useReportWebVitals(sendWebVitalsResultsToAnalytics)
  return null
}
